module.exports = __webpack_public_path__ + "img/hospital-user.8d320f47.svg";